export default __webpack_public_path__ + "static/media/gallery-08_full.73244e65.jpg";